import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "downloadMenu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", 
      this.menuTarget.classList.contains("hidden") ? "false" : "true"
    )
  }

  toggleDownload(event) {
    event.stopPropagation()
    if (this.hasDownloadMenuTarget) {
      this.downloadMenuTarget.classList.toggle("hidden")
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.element.querySelector("button").setAttribute("aria-expanded", "false")
    if (this.hasDownloadMenuTarget) {
      this.downloadMenuTarget.classList.add("hidden")
    }
  }
}
